<!-- Update Firmware Button (actually only for Gateways) -->
<div *ngIf="hasUpdateFirmware() && !isAutomation && !isMtmacModel" class="grid">
	<div class="col-12" [class]="!isAutomation ? 'pt-0' : 'pt-3'">
		<div class="flex align-items-center justify-content-start flex-wrap">
			<p-button label="{{ 'FW_VERSION_UPDATE' | translate }}" 
				(click)="clickUpdateFirmware()"
				[disabled]="offline() || onFirmwareUpdate()" icon="pi cm-update-firmware"
				[rounded]="false" [text]="true" severity="warning" styleClass="font-bold border-yellow-600">
			</p-button>
		</div>
	</div>
</div>

<p-panel header="{{ categoryName  | translate }}">
	<div class="grid my-0">
		<div [ngClass]="col12Responsive()" *ngIf="!isVirtual">
			<app-retry-init></app-retry-init>
		</div>
		<div [ngClass]="col12Responsive()"
			*ngIf="device !== undefined && supportSignalLevel && device.CurrentlyOwned && isSignalLevelAvailable()">
			<app-signal-level [currentUser]="user"></app-signal-level>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="device !== undefined && device.CurrentlyOwned && hasDatetime()">
			<app-datetime-device></app-datetime-device>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasProgress()">
			<app-device-state-progress></app-device-state-progress>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasPeripheralNumber()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'CRP_ADDRESS' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ peripheralNumber }}
				</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasSerial()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'SERIAL_NUMBER' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ serial }}</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasKeycode()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'KEYCODE' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ keycode }}</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasProductType()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'PRODUCT_TYPE' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ productType }}</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasBoardType()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'BOARD_TYPE' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ boardType }}</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasProductName()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'PRODUCT_NAME' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ productName }}</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasHwVersion()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'HW_VERSION' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ hwVersion }}</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasFwVersion()">
			<!-- Gateways: update fw possible -->
			<!-- Automations: no update fw possible now -->
			<!-- Update fw: possible from new button on top page (see above this p-panel)-->
			<div class="card flex align-items-center justify-content-between flex-wrap font-bold px-4"
				[ngClass]="hasUpdateFirmware() ? 'bg-yellow-200' : ''">
				<div class="flex">
					{{ hasUpdateFirmware() ? ('FW_VERSION_UPDATE' |translate ) : ('FW_VERSION' | translate ) }}
				</div>
				<!-- READING FW VERSION (available only for Automations)-->
				<div *ngIf="readingFwVer" class="flex">
					<p-progressSpinner ariaLabel="loading" styleClass="w-4rem h-2rem"
						strokeWidth="4"></p-progressSpinner>
				</div>
				<!-- Not reading fw version -->
				<div *ngIf="!readingFwVer" class="flex align-items-center gap-2">
					<!-- RELEASE NOTE DESKTOP / TABLET -->
					<p-button *ngIf="!onExtendedMobile()" label="{{ 'RELEASE_NOTE_DEVICE' | translate }}" 
						[disabled]="!releaseNoteAvailable"
						(click)="showReleaseNote()" [rounded]="false" [text]="true" 
						[severity]="hasUpdateFirmware() ? 'warning' : 'primary'"
						styleClass="font-semibold">
					</p-button>
					<!-- RELEASE NOTE MOBILE -->
					<p-button *ngIf="onExtendedMobile()" pTooltip="{{ 'RELEASE_NOTE_DEVICE' | translate }}"
						[disabled]="!releaseNoteAvailable"
						[severity]="hasUpdateFirmware() ? 'warning' : 'primary'"
						tooltipPosition="bottom" icon="pi cm-info" size="large" (click)="showReleaseNote()" [rounded]="false"
						[text]="true">
					</p-button>
					<!-- UPDATE_VERSION_FW: Leggi versione firmware attuale -->
					<p-button *ngIf="isAutomation" class="pr-2" pTooltip="{{'UPDATE_VERSION_FW' | translate }}"
						tooltipPosition="bottom" icon="pi cm-reload" size="large" (click)="readFwVerButton()" [rounded]="false"
						[text]="true" severity="primary" [disabled]="!deviceConfiguredOnline()">
					</p-button>
					<!-- FW VERSION -->
					<div>{{ fwVersion }}</div>
				</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasError()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'ERROR' | translate
					}}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ deviceError }}</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasManeuvers()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'MANEUVERS' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ maneuvers }}</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasLastSeen()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'DATE_LAST_EVENT' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ lastSeen |
					localizedDate:'medium' }}</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasImei()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'IMEI_CODE' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ imeiCode }}</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="isGwEth()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'CONNECTION_TYPE' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ connType | translate}}</div>
			</div>
		</div>
	</div>
</p-panel>
